export default "/fonts/vendor/@fontsource/fraunces/files/fraunces-vietnamese-400-normal.woff2?c85b58165a1ac16cc87f19e0fef3db90";